import React from "react";
import images from "../data/images"; // Make sure each object has 'heading', 'desc' and new 'extraDesc'

const Ourprojects = () => {
  return (
    <div className="custom-portfolio-wrapper px-4 md:px-10 py-10">
      
      <div className="text-center mb-10">
        <p className="text-sm font-semibold text-blue-600">OUR PORTFOLIO</p>
        <h1 className="text-2xl md:text-4xl font-bold text-gray-800">
          Explore Our Journey of Creative Excellence
        </h1>
        <hr className="w-24 mx-auto mt-4 border-t-4 border-blue-500 rounded" />
      </div>

      <div className="space-y-16">
        {images.map((image, index) => {
          const isEven = index % 2 === 0;
          const layoutClass = isEven
            ? "portfolio-image-left"
            : "portfolio-image-right";

          return (
            <div
              key={index}
              className={`flex flex-col md:flex-row ${
                !isEven ? "md:flex-row-reverse" : ""
              } items-center gap-8 ${layoutClass}`}
            >
              {/* Image Section */}
              <div className="md:w-1/2 w-full custom-portfolio-image">
                <img
                  src={image.imgURL}
                  alt={image.imgAlt}
                  className=" rounded-lg shadow-lg object-cover image"
                />
              </div>

              {/* Content Section */}
              <div className="md:w-1/2 w-full custom-portfolio-content space-y-4">
                {image.heading && (
                  <h3 className="text-xl md:text-2xl font-semibold text-gray-800">
                    {image.heading}
                  </h3>
                )}
                {image.desc && (
                  <p className="text-gray-600 text-base md:text-lg">
                    {image.desc}
                  </p>
                )}
                {image.extraDesc && (
                  <p className="text-gray-500 text-sm md:text-base">
                    {image.extraDesc}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Ourprojects;
